<template>
  <div id="index">
    <el-container>
      <el-scrollbar :class="isCollapse ? 'menu_hide rightSide' : 'rightSide'">
        <el-main>
          <nav-bar></nav-bar>
          <el-form
            ref="formselect"
            :model="formselect"
            label-width="180px"
            class="queryform_div"
          >
            <el-row :gutter="24">
              <el-col :md="8" :xs="24" :sm="24">
                <el-form-item :label="$t('title.controllCcn')">
                  <el-input
                    style="width: 100%"
                    v-model="searchCcn"
                    size="small"
                  ></el-input>
                </el-form-item>
              </el-col>
              <el-col :md="8" :xs="24" :sm="24">
                <el-form-item :label="$t('title.ccnVersion')">
                  <el-select
                    size="small"
                    v-model="searchCcnVersion"
                    filterable
                    :placeholder="$t('desc.select')"
                    style="width: 100%"
                  >
                    <el-option key="" :label="$t('desc.select')" value="">
                    </el-option>
                    <el-option
                      v-for="item in ccnVersionList"
                      :key="item"
                      :label="item"
                      :value="item"
                    >
                    </el-option>
                  </el-select>
                </el-form-item>
              </el-col>
              <!-- <el-col :md="8" :xs="24" :sm="24">
                <el-form-item :label="$t('title.brandDisplay')">
                  <el-select
                    size="small"
                    v-model="searchBrand"
                    filterable
                    :placeholder="$t('desc.select')"
                    style="width: 100%"
                  >
                    <el-option
                      key=""
                      :label="$t('desc.select')"
                      value=""
                    >
                    </el-option>
                    <el-option
                      v-for="item in brandList"
                      :key="item.brandCode"
                      :label="item.brandName"
                      :value="item.brandCode"
                    >
                    </el-option>
                  </el-select>
                </el-form-item>
              </el-col> -->
              <el-col :md="6" :xs="24" :sm="24" style="margin-top: 10px">
                <el-button
                  type="primary"
                  v-on:click="getCcnInfoList('search')"
                  size="small"
                  >{{ $t("button.query") }}</el-button
                >
                <el-button v-on:click="cancelQuery" size="small">{{
                  $t("button.reset")
                }}</el-button>
              </el-col>
            </el-row>
          </el-form>
          <template>
            <!-- <el-button
              type="primary"
              icon="el-icon-circle-plus-outline"
              @click="showAdd"
              style="margin-bottom: 10px"
              v-if="hasCreateAuth"
              >{{ $t("button.addCcn") }}</el-button
            > -->
            <el-button
              type="primary"
              plain
              icon="el-icon-circle-plus-outline"
              @click="showGather"
              style="margin-bottom: 10px"
              >{{ $t("title.ccnDirectory") }}</el-button
            >
            <el-button
              v-if="hasExportAuth"
              type="primary"
              plain
              icon="el-icon-download"
              @click="exportCcnList"
              style="margin-bottom: 10px"
              >{{ $t("title.ccnExportTitle") }}</el-button
            >

            <el-button
              v-if="hasGatherUnitAuth"
              type="primary"
              @click="jumpGatherUnit()"
              style="margin-bottom: 10px"
              >{{ $t("menu.GatherUnit_View") }}</el-button
            >
            <!-- <el-button
              type="default"
              icon="el-icon-upload2"
              @click="showImportDialog(true)"
              style="margin-bottom: 10px"
              v-show="hasImportAuth"
              >{{ $t("button.bulkImport") }}</el-button
            >

            <a
              class="el-button el-button--default el-button--small"
              style="margin-bottom: 10px; text-decoration: none; float: right"
              href="/file/EXCEL导入模板-点表.xlsx"
              download="EXCEL导入模板-点表.xlsx"
              >{{ $t("desc.exportTemplate") }}</a
            > -->
            <div class="tableDiv">
              <el-table
                :data="tableData1"
                v-loading="tableLoading"
                stripe
                style="width: 100%"
                :empty-text="$t('desc.noData')"
              >
                <el-table-column
                  type="index"
                  :label="$t('title.serialNumber')"
                  width="60"
                >
                </el-table-column>
                <el-table-column
                  prop="ccn"
                  :label="$t('title.controllCcn')"
                  min-width="10%"
                >
                </el-table-column>
                <el-table-column
                  prop="version"
                  :label="$t('title.ccnVersion')"
                  min-width="8%"
                >
                </el-table-column>
                <el-table-column
                  prop="ccnModel"
                  :label="$t('title.controllerModel')"
                  min-width="8%"
                >
                </el-table-column>
                <el-table-column
                  prop="brandCode"
                  :label="$t('title.brandDisplay')"
                  min-width="8%"
                >
                </el-table-column>
                <el-table-column
                  prop="creationTime"
                  :label="$t('title.ccnCreateTime')"
                  min-width="10%"
                >
                </el-table-column>
                <el-table-column
                  prop="lastModificationTime"
                  :label="$t('title.ccnModifyTime')"
                  min-width="10%"
                >
                </el-table-column>
                <!-- <el-table-column
                prop="creatorUserId"
                :label="$t('title.creator')"
                min-width="10%"
              >
              </el-table-column> -->
                <el-table-column
                  :label="$t('title.operate')"
                  width="260"
                  fixed="right"
                >
                  <template slot-scope="scope">
                    <!--                  <el-tooltip placement="top">-->
                    <!--                    <div slot="content">{{ $t("button.pushCcnTable") }}</div>-->
                    <el-button
                      icon="el-icon-position"
                      type="warning"
                      :title="$t('button.pushCcnTable')"
                      circle
                      size="mini"
                      :loading="pushBtnLoading[scope.$index]"
                      @click="
                        pushGatherTable(
                          scope.row.ccn,
                          scope.row.version,
                          scope.$index
                        )
                      "
                      v-if="hasPushGatherAuth"
                    ></el-button>
                    <!--                  </el-tooltip>-->
                    <!--                  <el-tooltip placement="top">-->
                    <!--                    <div slot="content">{{ $t("button.upCcnVersion") }}</div>-->
                    <el-button
                      type="primary"
                      :title="$t('button.upCcnVersion')"
                      icon="el-icon-finished"
                      circle
                      size="mini"
                      @click="
                        showUpgrade(
                          scope.row.ccn,
                          scope.row.version,
                          scope.row.ccnModel
                        )
                      "
                      v-if="
                        hasUpdateAuth &&
                        scope.row.version == scope.row.maxVersion
                      "
                    ></el-button>
                    <el-button
                      type="primary"
                      :title="$t('button.copyCcn')"
                      icon="el-icon-document-copy"
                      circle
                      size="mini"
                      @click="
                        showCopyCcn(
                          scope.row.ccn,
                          scope.row.version,
                          scope.row.ccnModel
                        )
                      "
                      v-if="hasUpdateAuth"
                    ></el-button>
                    <!--                  </el-tooltip>-->

                    <el-button
                      type="success"
                      icon="el-icon-edit"
                      :title="$t('button.update')"
                      circle
                      size="mini"
                      v-if="hasUpdateAuth"
                      @click="
                        showEdit(
                          scope.row.ccn,
                          scope.row.version,
                          scope.row.ccnModel,
                          scope.row.brandCode
                        )
                      "
                    ></el-button>
                    <el-button
                      type="default"
                      icon="el-icon-download"
                      :title="$t('title.ccnExportTitle')"
                      circle
                      size="mini"
                      v-if="hasExportAuth"
                      @click="exportCcn(scope.row.ccn, scope.row.version)"
                    ></el-button>
                    <template>
                      <el-popconfirm
                        placement="top"
                        :confirmButtonText="$t('button.confirm')"
                        :cancelButtonText="$t('button.cancel')"
                        icon="el-icon-info"
                        iconColor="red"
                        :title="$t('title.confirmDelete')"
                        @confirm="deleteCcnInfoById(scope.row.id)"
                      >
                        <el-button
                          type="danger"
                          icon="el-icon-delete"
                          :title="$t('button.delete')"
                          circle
                          size="mini"
                          slot="reference"
                          v-if="hasDeleteAuth"
                        ></el-button>
                      </el-popconfirm>
                    </template>
                  </template>
                </el-table-column>
              </el-table>
              <el-pagination
                background
                layout="prev, pager, next"
                :total="pagination.totalPage"
                :current-page.sync="pagination.current"
                :page-size="pagination.pageSize"
                @current-change="getCcnInfoList()"
                style="text-align: center; margin-top: 10px"
              ></el-pagination>
            </div>
          </template>
        </el-main>
      </el-scrollbar>
    </el-container>
    <!--新增编辑CCN弹窗-->
    <el-dialog
      :title="
        ccnform.type == '1' || ccnform.type == '4'
          ? $t('title.addCcnTitle')
          : ccnform.type == '2'
          ? $t('title.editCcnTitle')
          : $t('title.upGradeCcnTitle')
      "
      :visible.sync="dialogAddCCN"
      width="90%"
      top="5%"
      class="abow_dialog"
    >
      <el-form ref="ccnform" :model="ccnform" label-width="100px">
        <el-row :gutter="24">
          <el-col :span="6">
            <el-form-item :label="$t('title.controllCcn')">
              <el-input
                v-model="ccnform.ccn"
                :readonly="
                  ccnform.type == '1' || ccnform.type == '4' ? false : true
                "
              ></el-input>
            </el-form-item>
          </el-col>
          <el-col :span="6">
            <el-form-item :label="$t('title.ccnVersion')">
              <el-input
                :placeholder="$t('desc.autogeneration')"
                v-model="ccnform.version"
                :readonly="true"
              ></el-input>
            </el-form-item>
          </el-col>
          <el-col :span="6">
            <el-form-item :label="$t('title.controllerModel')">
              <el-input v-model="ccnform.ccnmodel"></el-input>
            </el-form-item>
          </el-col>
          <el-col :md="6" :xs="24" :sm="24">
            <el-form-item :label="$t('title.brandDisplay')">
              <el-select
                size="small"
                v-model="ccnform.brand"
                disabled
                :placeholder="$t('desc.select')"
              >
                <el-option
                  v-for="item in brandList"
                  :key="item.brandCode"
                  :label="item.brandName"
                  :value="item.brandCode"
                >
                </el-option>
              </el-select>
            </el-form-item>
          </el-col>
        </el-row>

        <el-form-item
          style="
            position: absolute;
            margin-top: 20px;
            margin-left: 250px;
            z-index: 100;
          "
        >
          <el-button
            type="default"
            icon="el-icon-upload2"
            @click="showImportExpertAdviceDialog(true)"
            style="margin-bottom: 10px"
            v-show="hasImportAuth"
            >{{ $t("button.bulkImportExpertAdvice") }}</el-button
          >
          <a
            v-if="activeLang == 'en'"
            class="el-button el-button--default el-button--small"
            style="margin-bottom: 10px; text-decoration: none; float: right"
            href="/file/Excel Import Template - Ccn Expert Advice.xlsx"
            download="Excel Import Template - Ccn Expert Advice.xlsx"
            >{{ $t("desc.exportExpertAdviceTemplate") }}</a
          >
          <a
            v-else
            class="el-button el-button--default el-button--small"
            style="margin-bottom: 10px; text-decoration: none; float: right"
            href="/file/EXCEL导入模板-点表专家建议.xlsx"
            download="EXCEL导入模板-点表专家建议.xlsx"
            >{{ $t("desc.exportExpertAdviceTemplate") }}</a
          >
        </el-form-item>

        <el-tabs
          v-model="ActiveTab"
          @tab-click="handleClick"
          style="margin-top: 20px"
        >
          <el-tab-pane name="first">
            <span slot="label"
              ><i class="el-icon-s-order"></i> {{ $t("title.ccnTable") }}</span
            >
            <div class="DBDiv">
              <div class="tableDiv">
                <el-table
                  :data="CCNTable"
                  ref="CCNTable"
                  @selection-change="handleSelectionChange"
                  @row-click="CCNbtn"
                  stripe
                  class="formSTable ccntable"
                  :empty-text="$t('desc.noData')"
                  :height="CCNheight"
                >
                  <el-table-column type="selection" width="50">
                  </el-table-column>
                  <el-table-column
                    type="index"
                    :label="$t('title.serialNumber')"
                    width="60"
                  >
                  </el-table-column>
                  <el-table-column
                    :label="$t('title.monitorIndex')"
                    prop="name"
                    min-width="30%"
                  >
                  </el-table-column>
                  <el-table-column
                    :label="$t('title.monitorDesc')"
                    prop="nameZH"
                    min-width="20%"
                  >
                  </el-table-column>
                  <el-table-column
                    :label="$t('title.monitorDataType')"
                    prop="type"
                    min-width="15%"
                  >
                  </el-table-column>
                  <el-table-column
                    :label="$t('title.monitorUnit')"
                    prop="unit"
                    min-width="15%"
                  >
                  </el-table-column>
                  <el-table-column
                    :label="$t('title.monitorType')"
                    prop="rateType"
                    min-width="15%"
                  >
                  </el-table-column>
                  <el-table-column
                    :label="$t('title.monitorAddress')"
                    min-width="15%"
                  >
                    <template slot-scope="scope">
                      <el-input
                        ref="addressInputRef"
                        v-model="scope.row.address"
                      >
                      </el-input>
                    </template>
                  </el-table-column>
                  <el-table-column label="偏移量" min-width="15%">
                    <template slot-scope="scope">
                      <el-input ref="offsetInputRef" v-model="scope.row.offset">
                      </el-input>
                    </template>
                  </el-table-column>
                  <el-table-column label="缩放量" min-width="15%">
                    <template slot-scope="scope">
                      <el-input ref="scaleInputRef" v-model="scope.row.scale">
                      </el-input>
                    </template>
                  </el-table-column>
                </el-table>
              </div>
            </div>
          </el-tab-pane>
          <el-tab-pane name="second">
            <span slot="label"
              ><i class="el-icon-s-release"></i>
              {{ $t("title.ccnErrorInfo") }}</span
            >
            <div class="DBDiv">
              <div class="tableDiv">
                <el-table
                  :data="FaultTable"
                  ref="FaultTable"
                  stripe
                  class="formSTable faulttable"
                  :style="{ height: faulttableHeight + 'px' }"
                  :empty-text="$t('desc.noData')"
                  :height="CCNheight2"
                >
                  <el-table-column
                    type="index"
                    :label="$t('title.serialNumber')"
                    width="60"
                  >
                  </el-table-column>
                  <el-table-column
                    :label="$t('title.errorCode')"
                    v-model="FaultTable.faultcode"
                    min-width="20%"
                  >
                    <template slot-scope="scope">
                      <el-input v-model="scope.row.faultcode"></el-input>
                    </template>
                  </el-table-column>
                  <el-table-column
                    :label="$t('title.errorDescription')"
                    v-model="FaultTable.faultcn"
                    min-width="30%"
                  >
                    <template slot-scope="scope">
                      <el-input v-model="scope.row.faultcn"></el-input>
                    </template>
                  </el-table-column>
                  <el-table-column
                    :label="$t('title.errorType')"
                    v-model="FaultTable.faulttype"
                    min-width="30%"
                  >
                    <template slot-scope="scope">
                      <el-select
                        v-model="scope.row.faulttype"
                        :placeholder="$t('desc.select')"
                      >
                        <el-option
                          key="Warning"
                          label="Warning"
                          value="Warning"
                        ></el-option>
                        <el-option
                          key="Trip"
                          label="Trip"
                          value="Trip"
                        ></el-option>
                      </el-select>
                    </template>
                  </el-table-column>
                  <el-table-column :label="$t('title.operate')" width="150">
                    <template slot-scope="scope">
                      <el-popconfirm
                        placement="top"
                        :confirmButtonText="$t('button.confirm')"
                        :cancelButtonText="$t('button.cancel')"
                        icon="el-icon-info"
                        iconColor="red"
                        :title="$t('title.confirmDelete')"
                        :ref="`popoverCcnError-${scope.$index}`"
                        v-if="hasDeleteAuth"
                        @confirm="delFaultRow(scope.$index, scope.row)"
                      >
                        <el-button
                          icon="el-icon-delete"
                          circle
                          size="mini"
                          type="danger"
                          slot="reference"
                        ></el-button>
                      </el-popconfirm>
                    </template>
                  </el-table-column>
                </el-table>
              </div>
            </div>

            <el-button
              class="el-icon-plus"
              size="small"
              v-if="hasCreateAuth"
              @click.prevent="addFaulRow()"
            ></el-button>
          </el-tab-pane>
          <el-tab-pane name="third">
            <span slot="label"
              ><i class="el-icon-s-release"></i>
              {{ $t("title.ccnExpertAdviceInfo") }}</span
            >
            <div class="DBDiv">
              <div class="tableDiv">
                <el-table
                  :data="FaultTable"
                  ref="AdviceTable"
                  stripe
                  class="formSTable faulttable"
                  :style="{ height: faulttableHeight + 'px' }"
                  :empty-text="$t('desc.noData')"
                  :height="CCNheight"
                >
                  <el-table-column
                    type="index"
                    :label="$t('title.serialNumber')"
                    width="60"
                  >
                  </el-table-column>
                  <el-table-column
                    :label="$t('title.errorCode')"
                    v-model="FaultTable.faultcode"
                    min-width="20%"
                  >
                    <template slot-scope="scope">
                      <el-input
                        readonly
                        disabled
                        v-model="scope.row.faultcode"
                      ></el-input>
                    </template>
                  </el-table-column>
                  <el-table-column
                    :label="$t('title.errorDescription')"
                    v-model="FaultTable.faultcn"
                    min-width="30%"
                  >
                    <template slot-scope="scope">
                      <el-input
                        readonly
                        disabled
                        v-model="scope.row.faultcn"
                      ></el-input>
                    </template>
                  </el-table-column>
                  <el-table-column
                    :label="$t('title.errorType')"
                    v-model="FaultTable.faulttype"
                    min-width="30%"
                  >
                    <template slot-scope="scope">
                      <el-input
                        readonly
                        disabled
                        v-model="scope.row.faulttype"
                      ></el-input>
                    </template>
                  </el-table-column>

                  <el-table-column
                    :label="$t('title.expertAdvice')"
                    v-model="FaultTable.expertAdvice"
                    min-width="30%"
                  >
                    <template slot-scope="scope">
                      <el-input v-model="scope.row.expertAdvice"></el-input>
                    </template>
                  </el-table-column>
                  <el-table-column :label="$t('title.operate')" width="100">
                    <template slot-scope="scope">
                      <el-button
                        type="primary"
                        icon="el-icon-document"
                        :title="$t('button.viewExpertAdvice')"
                        circle
                        size="mini"
                        @click="openWarningInfoDialog(scope.row)"
                      ></el-button>
                    </template>
                  </el-table-column>
                </el-table>
              </div>
            </div>
          </el-tab-pane>
        </el-tabs>

        <el-form-item style="margin-bottom: 0; margin-top: 10px">
          <el-button type="success" :plain="true" v-on:click="addCcnGather">{{
            $t("button.confirm")
          }}</el-button>
          <el-button v-on:click="cancelCcnGather">{{
            $t("button.cancel")
          }}</el-button>
        </el-form-item>
      </el-form>
    </el-dialog>
    <!--点表总目录弹窗-->
    <el-dialog
      :title="$t('title.ccnDirectory')"
      :visible.sync="dialogDBMenu"
      width="70%"
      top="5%"
      class="abow_dialog"
    >
      <el-form
        ref="gatherMainSearchform"
        :model="gatherMainSearchform"
        label-width="80px"
        style="height: 100%"
      >
        <el-row :gutter="24">
          <el-col :md="6" :xs="24" :sm="24">
            <el-form-item :label="$t('title.monitorIndex')">
              <el-input
                style="width: 100%"
                v-model="gatherMainSearchform.searchGatherName"
                size="small"
              ></el-input>
            </el-form-item>
          </el-col>
          <el-col :md="6" :xs="24" :sm="24">
            <el-form-item
              label-width="100px"
              :label="$t('title.controllerModel')"
            >
              <!-- <el-input
                style="width: 100%"
                v-model="gatherMainSearchform.searchCcnModel"
                size="small"
              ></el-input> -->

              <el-select
                size="small"
                v-model="gatherMainSearchform.searchCcnModel"
                filterable
                :placeholder="$t('desc.select')"
                style="width: 100%"
              >
                <el-option key="" label="全部" value=""></el-option>
                <el-option
                  key="Xe-145F"
                  label="Xe-145F"
                  value="Xe-145F"
                ></el-option>
                <el-option key="MU" label="MU" value="MU"></el-option>
              </el-select>
            </el-form-item>
          </el-col>
          <el-col :md="6" :xs="24" :sm="24">
            <el-form-item :label="$t('title.monitorType')">
              <el-select
                size="small"
                v-model="gatherMainSearchform.searchRateType"
                filterable
                :placeholder="$t('desc.select')"
                style="width: 100%"
              >
                <el-option key="" label="全部" value=""></el-option>
                <el-option
                  key="onTrip"
                  label="onTrip"
                  value="onTrip"
                ></el-option>
                <el-option
                  key="onWarning"
                  label="onWarning"
                  value="onWarning"
                ></el-option>
                <el-option
                  key="onTrip|onWarning"
                  label="onTrip|onWarning"
                  value="onTrip|onWarning"
                ></el-option>
                <el-option
                  key="Timing"
                  label="Timing"
                  value="Timing"
                ></el-option>
                <el-option
                  key="onConnect"
                  label="onConnect"
                  value="onConnect"
                ></el-option>
                <el-option
                  key="onStart"
                  label="onStart"
                  value="onStart"
                ></el-option>
              </el-select>
            </el-form-item>
          </el-col>
          <el-col :md="6" :xs="24" :sm="24" style="margin-top: 25px">
            <el-button
              type="primary"
              v-on:click="searchGatherMainList()"
              size="small"
              >{{ $t("button.query") }}</el-button
            >
            <el-button v-on:click="cancelGatherQuery" size="small">{{
              $t("button.reset")
            }}</el-button>
          </el-col>
        </el-row>
        <template>
          <el-button
            type="primary"
            icon="el-icon-circle-plus-outline"
            @click="showGatherAdd"
            style="margin-bottom: 10px; margin-top: 10px"
            v-if="hasCreateAuth"
            >{{ $t("title.AddPointTableData") }}</el-button
          >
          <el-button
            type="primary"
            plain
            icon="el-icon-download"
            @click="exportGatherList"
            style="margin-bottom: 10px; margin-top: 10px"
            >{{ $t("title.gtherExportTitle") }}</el-button
          >
          <div class="DBDiv">
            <div class="tableDiv">
              <el-table
                :data="DBGatherMainTable"
                ref="DBGatherMainTable"
                stripe
                class="formSTable"
                :style="{ height: DBTableHeight + 'px' }"
                :empty-text="$t('desc.noData')"
              >
                <el-table-column
                  type="index"
                  :label="$t('title.serialNumber')"
                  width="60"
                >
                </el-table-column>
                <el-table-column
                  :label="$t('title.monitorIndex')"
                  min-width="20%"
                  prop="name"
                >
                  <!-- <template slot-scope="scope">
              <el-input v-model="scope.row.name"></el-input>
            </template> -->
                </el-table-column>
                <el-table-column
                  :label="$t('title.monitorDesc')"
                  min-width="20%"
                  prop="nameZH"
                >
                  <!-- <template slot-scope="scope">
              <el-input v-model="scope.row.nameZH"></el-input>
            </template> -->
                </el-table-column>
                <el-table-column
                  :label="$t('title.monitorDataType')"
                  min-width="8%"
                  prop="type"
                >
                </el-table-column>
                <el-table-column
                  :label="$t('title.monitorUnit')"
                  min-width="8%"
                  prop="unit"
                >
                </el-table-column>
                <el-table-column
                  :label="$t('title.monitorAddress')"
                  min-width="8%"
                  prop="rate"
                >
                </el-table-column>
                <el-table-column
                  :label="$t('title.monitorType')"
                  min-width="12%"
                  prop="rateType"
                >
                  <!-- <template slot-scope="scope">
              <el-input v-model="scope.row.rateType"></el-input>
            </template> -->
                </el-table-column>
                <el-table-column
                  :label="$t('title.pacControllerType')"
                  min-width="10%"
                  prop="presetDesc"
                >
                </el-table-column>
                <el-table-column
                  :label="$t('title.default')"
                  min-width="10%"
                  prop="isPreset"
                >
                  <template slot-scope="scope">
                    <label>{{
                      scope.row.isPreset === true
                        ? $t("desc.yes")
                        : $t("desc.no")
                    }}</label>
                  </template>
                </el-table-column>
                <el-table-column
                  :label="$t('title.offset')"
                  min-width="8%"
                  prop="offset"
                >
                </el-table-column>
                <el-table-column
                  :label="$t('title.scale')"
                  min-width="8%"
                  prop="scale"
                >
                </el-table-column>
                <el-table-column v-if="hasUpdateAuth || hasDeleteAuth" :label="$t('title.operate')" width="100px">
                  <template slot-scope="scope">
                    <el-button
                      type="primary"
                      icon="el-icon-edit"
                      circle
                      size="mini"
                      v-if="hasUpdateAuth"
                      @click="showGatherEdit(scope.row)"
                    ></el-button>
                    <template v-if="hasDeleteAuth">
                      <el-popconfirm
                        placement="top"
                        :confirmButtonText="$t('button.confirm')"
                        :cancelButtonText="$t('button.cancel')"
                        icon="el-icon-info"
                        iconColor="red"
                        :title="$t('title.confirmDelete')"
                        @confirm="deleteGather(scope.row.id)"
                      >
                        <el-button
                          icon="el-icon-delete"
                          circle
                          size="mini"
                          slot="reference"
                          type="danger"
                        ></el-button>
                      </el-popconfirm>
                    </template>
                  </template>
                </el-table-column>
              </el-table>
            </div>
          </div>

          <!-- <el-button
          class="el-icon-plus"
          size="small"
          v-if="hasCreateAuth"
          @click.prevent="addDBRow()"
        ></el-button>
        <el-form-item>
          <el-button
            type="success"
            @click="saveGather"
            v-if="hasCreateAuth || hasUpdateAuth"
            >{{ $t("button.confirm") }}</el-button
          >
          <el-button
            @click="dialogDBMenu = false"
            v-if="hasCreateAuth || hasUpdateAuth"
            >{{ $t("button.cancel") }}</el-button
          >
        </el-form-item> -->
          <!-- </el-form> -->
        </template>
      </el-form>
    </el-dialog>

    <!--新增编辑总点表-->
    <el-dialog
      :title="addGatherTitle"
      :visible.sync="dialogAddGather"
      width="50%"
      top="5vh"
    >
      <el-form ref="formRef" :model="gatherform" label-width="130px">
        <el-form-item :label="$t('title.monitorIndex')">
          <el-input v-model="gatherform.name"></el-input>
        </el-form-item>
        <el-form-item :label="$t('title.monitorDesc')">
          <el-input v-model="gatherform.nameZH"></el-input>
        </el-form-item>        
        <el-form-item :label="$t('title.monitorDataType')">
          <el-select
            size="small"
            v-model="gatherform.type"
            :placeholder="$t('desc.select')"
          >
            <el-option
              v-for="item in gatherDataTypeList"
              :key="item"
              :label="item"
              :value="item"
            >
            </el-option>
          </el-select>
        </el-form-item>
        <el-form-item :label="$t('title.monitorUnit')">
          <el-select
            size="small"
            v-model="gatherform.unit"
            :placeholder="$t('desc.select')"
          >
            <el-option
              v-for="item in gatherUnitList"
              :key="item"
              :label="item"
              :value="item"
            >
            </el-option>
          </el-select>
        </el-form-item>

        <!-- <el-form-item :label="$t('title.monitorUnit')">
          <el-select v-model="gatherform.unit" :placeholder="$t('desc.select')">
            <el-option key="nounit" label="nounit" value="nounit"></el-option>
            <el-option
              key="percent"
              label="percent"
              value="percent"
            ></el-option>
            <el-option key="flow" label="flow" value="flow"></el-option>
            <el-option key="℃" label="℃" value="℃"></el-option>
            <el-option key="hour" label="hour" value="hour"></el-option>
            <el-option key="%" label="%" value="%"></el-option>
            <el-option key="A" label="A" value="A"></el-option>
            <el-option key="bar" label="bar" value="bar"></el-option>
            <el-option key="micron" label="micron" value="micron"></el-option>
          </el-select>
        </el-form-item> -->
        <el-form-item :label="$t('title.monitorAddress')">
          <el-input v-model="gatherform.rate" style="width: 225px"> </el-input>
        </el-form-item>
        <el-form-item :label="$t('title.monitorType')">
          <el-select
            v-model="gatherform.rateType"
            :placeholder="$t('desc.select')"
          >
            <el-option key="onTrip" label="onTrip" value="onTrip"></el-option>
            <el-option
              key="onWarning"
              label="onWarning"
              value="onWarning"
            ></el-option>
            <el-option key="Timing" label="Timing" value="Timing"></el-option>
            <el-option
              key="onConnect"
              label="onConnect"
              value="onConnect"
            ></el-option>
            <el-option
              key="onStart"
              label="onStart"
              value="onStart"
            ></el-option>
          </el-select>
        </el-form-item>
        <el-form-item :label="$t('title.controllerModel')">
          <el-select
            size="small"
            v-model="gatherform.presetDesc"
            :placeholder="$t('desc.select')"
            style="max-width: 230px"
          >
            <el-option label="Xe-145F" value="Xe-145F"> </el-option>
            <el-option label="MU" value="MU"> </el-option>
          </el-select>
        </el-form-item>
        <el-form-item :label="$t('title.default')">
          <el-select
            size="small"
            v-model="gatherform.isPreset"
            :placeholder="$t('desc.select')"
            style="max-width: 230px"
          >
            <el-option :label="$t('desc.yes')" :value="true"> </el-option>
            <el-option :label="$t('desc.no')" :value="false"> </el-option>
          </el-select>
        </el-form-item>
        <el-form-item :label="$t('title.offset')">
          <el-input v-model="gatherform.offset" style="width: 225px"></el-input>
        </el-form-item>
        <el-form-item :label="$t('title.scale')">
          <el-input v-model="gatherform.scale" style="width: 225px"></el-input>
        </el-form-item>
        <el-form-item>
          <el-button
            type="success"
            @click="saveGather"
            v-if="hasCreateAuth || hasUpdateAuth"
            >{{ $t("button.confirm") }}</el-button
          >
          <el-button @click="dialogAddGather = false">{{
            $t("button.cancel")
          }}</el-button>
        </el-form-item>
      </el-form>
    </el-dialog>
    <import-dialog
      ref="importRef"
      :refForm="'airFormImport'"
      :title="(dialogTitle = $t('点表批量导入'))"
      :dialogImportClient="dialogImportClient"
      :form="form"
      @onSubBtn="uploadFile"
      @dialogVisibleEvent="showImportDialog"
    ></import-dialog>
    <import-dialog
      ref="importExpertAdviceRef"
      :refForm="'airFormImport'"
      :title="(dialogTitle = $t('专家建议导入'))"
      :dialogImportClient="dialogImportExpertAdviceClient"
      :form="form"
      @onSubBtn="uploadExpertAdvice"
      @dialogVisibleEvent="showImportExpertAdviceDialog"
    ></import-dialog>

    <el-dialog
      :title="$t('title.expertAdvice')"
      :visible.sync="dialogWarningInfo"
      width="80%"
      top="5vh"
      :before-close="doClose"
      :modal-append-to-body="false"
    >
      <div class="DeviceDiv AlarmInfo">
        <el-row
          :gutter="24"
          class="info"
          style="
            padding-top: 0;
            border-top: 0;
            margin-left: 0px !important;
            margin-right: 0px !important;
          "
        >
          <el-col :span="24">
            <span>{{ $t("title.errorCode") }}：</span>{{ TripInfo.faultcode }}
          </el-col>
          <el-col :span="24">
            <span>{{ $t("title.errorDescription") }}：</span
            >{{ TripInfo.faultcn }}
          </el-col>
          <el-col :span="24">
            <span>{{ $t("title.errorType") }}：</span>{{ TripInfo.faulttype }}
          </el-col>
          <el-col :span="24">
            <span>{{ $t("title.expertAdvice") }}：</span>
            <br />
            <div
              v-if="TripInfo.expertAdvice"
              class="tableDiv"
              style="
                vertical-align: top;
                width: calc(100% - 110px);
                display: inline-block;
              "
            >
              <el-table
                :data="TripInfo.expertAdviceList"
                stripe
                class="alarmTable"
              >
                <el-table-column
                  min-width="200"
                  prop="reason"
                  :label="$t('desc.possibleCauseOfFailure')"
                ></el-table-column>
                <el-table-column
                  min-width="200"
                  prop="solution"
                  :label="$t('desc.solution')"
                >
                </el-table-column>
              </el-table>
            </div>
          </el-col>
        </el-row>
      </div>
    </el-dialog>
  </div>
</template>
<script>
import {
  getCcnInfos,
  getCcnInfosPage,
  getGatherInfos,
  getExportGatherInfos,
  getCcnGatherList,
  getCcnGather,
  addCcnGather,
  deleteCcnInfoById,
  saveGatherList,
  editCcnGather,
  pushGatherTablePac,
  authOperationCheck,
  getCcnVersionList,
  addGather,
  updateGather,
  deleteGather,
  importCcnInfosPac,
  exportExcel,
  getCcnExportInfo,
  getCcnExportInfoList,
  exportExcelCcn,
  exportExcelCcnList,
  dateFormat,
  getBrandInfos,
  importExpertAdvices,
  exportExcelNew,
  getGatherUnitList,
  getGatherDataTypeList
} from "../../api/api";
import { mapState, mapGetters } from "vuex";
import ccnImportComponent from "../../components/content/maintabber/ImportExcelFiles";
// import XLSX from "xlsx";
export default {
  name: "index",
  components: {
    "import-dialog": ccnImportComponent,
  },
  data() {
    return {
      curType: "PAC",
      pushBtnLoading: [],
      ActiveTab: "first",
      dialogAddCCN: false,
      dialogDBMenu: false,
      dialogAddGather: false,
      addGatherTitle: "",
      dialogImportClient: false,
      dialogImportExpertAdviceClient: false,
      searchCcn: "",
      searchCcnVersion: "",
      searchBrand: "",
      popupTitle: "",
      hasUpdateAuth: false,
      hasDeleteAuth: false,
      hasCreateAuth: false,
      hasPushGatherAuth: false,
      hasExportAuth: false,
      hasImportAuth: false,
      hasGatherUnitAuth: false,
      tableData1: [
        /*{
          Ccn: "24236028",
        },
        {
          Ccn: "48864458",
        },*/
      ],
      gatherInfoList: [],
      gatherUnitList: [],
      gatherDataTypeList: [],
      formselect: {},
      ccnform: {
        ccn: "",
        type: "1",
        version: "",
        ccnmodel: "",
        brand: localStorage.getItem("user_brand")
          ? localStorage.getItem("user_brand")
          : "IR",
      },
      gatherMainSearchform: {
        searchGatherName: "",
        searchCcnModel: "",
        searchRateType: "",
      },
      upgradeCcnVersion: "",
      gatherform: {
        id: "",
        name: "",
        nameZH: "",
        type: "",
        unit: "",
        rate: "",
        rateType: "",
        presetDesc: "",
        offset: "",
        scale: "",
        isPreset: "",
      },
      form: {
        datalist: [],
      },
      props: { multiple: true },

      FaultTable: [
        {
          faultcode: "",
          faultcn: "",
          faulttype: "",
        },
      ],
      faultrowNum: 1,

      DBMenuTable: [
        // {
        //   name: "",
        //   nameZH: "",
        //   type: "",
        //   unit: "",
        //   rate: "",
        // },
      ],
      DBGatherMainTable: [],
      DBrowNum: 1,
      GatherDelData: [],
      AllCCNGatherList: [],
      CCNTable: [],
      CcnGatherData: [],
      ccnVersionList: [],
      CCNTableFlag: false,
      CCNheight: "",
      CCNheight2: "",
      faulttableHeight: "",
      DBTableHeight: "",
      brandList: [],
      scrollerHeight: "500",
      dialogWarningInfo: false,
      TripInfo: {
        faultcode: "",
        faultcn: "",
        faulttype: "",
        expertAdvice: [],
      },
      pagination: {
        current: 1,
        pageSize: 10,
        totalPage: 0,
      },
      tableLoading: false,
    };
  },
  mounted() {},
  computed: {
    ...mapGetters({
      activeLang: "language",
    }),
    ...mapState({
      isCollapse: (state) => state.isCollapse,
      navselected: (state) => state.adminleftnavnum,
    }),
  },
  created: function () {
    var that = this;

    this.getCcnVersionList();
    this.getBrandInfos();
    this.getCcnInfoList();
    this.getGatherInfoList();
    this.getGatherMainInfoList();
    this.authOperation("PacCcn");
    this.getGatherUnitList();
    this.getGatherDataTypeList();

    window.onresize = () => {
      this.setHeight();
    };
  },
  methods: {
    setHeight() {
      let Height = document.documentElement.clientHeight;
      if (Height > 580) {
        this.CCNheight = document.documentElement.clientHeight * 0.9 - 290;
        this.CCNheight2 = document.documentElement.clientHeight * 0.9 - 322;
      } else {
        this.CCNheight = 232;
        this.CCNheight2 = 200;
      }
    },
    getHeightStyle() {
      return parseInt(window.innerHeight) * 0.9 - 270 + "px";
      return {
        height: parseInt(window.innerHeight) * 0.9 - 270 + "px",
        "min-height": "500px",
      };
    },
    authOperation(curPage) {
      var that = this;
      var res = authOperationCheck(curPage);
      that.hasCreateAuth = res.hasCreateAuth;
      that.hasUpdateAuth = res.hasUpdateAuth;
      that.hasDeleteAuth = res.hasDeleteAuth;
      that.hasPushGatherAuth = res.hasPushGatherAuth;
      that.hasExportAuth = res.hasExportAuth;
      that.hasImportAuth = res.hasImportAuth;
      var resUnit = authOperationCheck("GatherUnit");
      that.hasGatherUnitAuth = resUnit.hasViewAuth;
    },
    getGatherUnitList() {
      let that = this;
      getGatherUnitList(that.curType).then((res) => {
        let data = res.result;
        that.gatherUnitList = data;
      });
    },
    getGatherDataTypeList() {
      let that = this;
      getGatherDataTypeList(that.curType).then((res) => {
        let data = res.result;
        that.gatherDataTypeList = data;
      });
    },
    async getBrandInfos() {
      let that = this;
      let res = await getBrandInfos();
      that.brandList = res.result;
    },
    getCcnVersionList() {
      let that = this;
      getCcnVersionList(that.curType).then((res) => {
        let data = res.result;
        that.ccnVersionList = data;
      });
    },
    getCcnInfoList(type = "normal") {
      let that = this;
      this.tableLoading = true;
      if (type == "search") {
        this.pagination.current = 1;
      }
      var searchCcn = that.searchCcn.trim();
      var searchCcnVersion = that.searchCcnVersion.trim();
      var searchBrand = that.searchBrand.trim();
      let skipCount = (this.pagination.current - 1) * this.pagination.pageSize;
      let maxResultCount = this.pagination.pageSize;
      getCcnInfosPage(
        searchCcn,
        searchCcnVersion,
        searchBrand,
        that.curType,
        skipCount,
        maxResultCount
      ).then((res) => {
        this.tableLoading = false;
        that.pagination.totalPage = res.result.totalCount;
        let data = res.result.items;
        if (data != null && data.length > 0) {
          data.forEach((o) => {
            that.pushBtnLoading.push(false);
            o.creationTime = o.creationTime
              .replace("T", " ")
              .replace("Z", "")
              .substr(0, 19);
            o.lastModificationTime = (o.lastModificationTime || "")
              .replace("T", " ")
              .replace("Z", "")
              .substr(0, 19);
            o.maxVersion = o.version;
            data.forEach((o2) => {
              if (o2.ccn == o.ccn) {
                if (parseInt(o2.version) > parseInt(o.maxVersion)) {
                  o.maxVersion = o2.version;
                }
              }
            });
          });
        }
        that.tableData1 = data;
      });
    },
    getGatherInfoList() {
      let that = this;
      getGatherInfos(that.curType).then((res) => {
        let data = res.result;
        if (data != null && data.length > 0) {
          data.forEach(function (o) {
            o.address = "";
          });
        }
        //that.DBMenuTable = data;
        that.AllCCNGatherList = data;
        //that.CCNTable = data;
      });
    },
    getGatherMainInfoList() {
      let that = this;
      getGatherInfos(that.curType).then((res) => {
        let data = res.result;
        if (data != null && data.length > 0) {
          data.forEach(function (o) {
            o.address = "";
            if (o.rate == 0) {
              o.rate = "";
            }
          });
        }
        that.DBMenuTable = data;
        that.searchGatherMainList();
      });
    },
    searchGatherMainList() {
      var that = this;
      if (
        that.gatherMainSearchform.searchGatherName != "" ||
        that.gatherMainSearchform.searchCcnModel != "" ||
        that.gatherMainSearchform.searchRateType != ""
      ) {
        var searchGatherMainList = [];
        that.DBMenuTable.forEach(function (o) {
          var isPush = true;
          if (that.gatherMainSearchform.searchGatherName != "") {
            if (
              o.name
                .toLocaleLowerCase()
                .indexOf(
                  that.gatherMainSearchform.searchGatherName.toLocaleLowerCase()
                ) < 0
            ) {
              isPush = false;
            }
          }
          if (that.gatherMainSearchform.searchCcnModel != "") {
            if (o.presetDesc != that.gatherMainSearchform.searchCcnModel) {
              isPush = false;
            }
          }
          if (that.gatherMainSearchform.searchRateType != "") {
            if (o.rateType != that.gatherMainSearchform.searchRateType) {
              isPush = false;
            }
          }
          if (isPush) {
            searchGatherMainList.push(o);
          }
        });
        that.DBGatherMainTable = searchGatherMainList;
      } else {
        that.DBGatherMainTable = that.DBMenuTable;
      }
    },
    pushGatherTable(ccn, ccnVersion, index) {
      let that = this;
      that.$set(that.pushBtnLoading, index, true);
      var para = {
        Ccn: ccn,
        CcnVersion: ccnVersion,
        Gsn: "",
      };
      pushGatherTablePac(para)
        .then((res) => {
          that.$set(that.pushBtnLoading, index, false);
          let ret = res.result;
          that.$message({
            message: that.$t("tips.saveSuccess"),
            type: "success",
          });
        })
        .catch((err) => {
          that.$set(that.pushBtnLoading, index, false);
          that.$message({
            showClose: true,
            message: err.error.message,
            type: "error",
          });
        });
    },
    saveGather() {
      let that = this;
      var paraData = {};
      paraData.id = that.gatherform.id;
      paraData.name = that.gatherform.name;
      paraData.nameZH = that.gatherform.nameZH;
      paraData.type = that.gatherform.type;
      paraData.unit = that.gatherform.unit;
      paraData.rate = that.gatherform.rate == "" ? 0 : that.gatherform.rate;
      paraData.rateType = that.gatherform.rateType;
      paraData.gatherType = that.curType;
      paraData.presetDesc = that.gatherform.presetDesc;
      paraData.offset = that.gatherform.offset;
      paraData.scale = that.gatherform.scale;
      paraData.isPreset = that.gatherform.isPreset;
      if (paraData.id == "") {
        addGather(paraData)
          .then((res) => {
            let data = res.result;
            that.dialogAddGather = false;
            that.getGatherMainInfoList();
            that.getGatherInfoList();
            that.$message({
              message: that.$t("tips.saveSuccess"),
              type: "success",
            });
          })
          .catch((err) => {
            that.$message({
              showClose: true,
              message: err.error.message,
              type: "error",
            });
          });
      } else {
        updateGather(paraData)
          .then((res) => {
            let data = res.result;
            that.dialogAddGather = false;
            that.getGatherMainInfoList();
            that.getGatherInfoList();
            that.$message({
              message: that.$t("tips.updateSuccess"),
              type: "success",
            });
          })
          .catch((err) => {
            that.$message({
              showClose: true,
              message: err.error.message,
              type: "error",
            });
          });
      }

      // that.DBMenuTable.forEach(function (o) {
      //   if (
      //     o.operateType != "" &&
      //     o.operateType != null &&
      //     o.operateType != undefined
      //   ) {
      //     paraData.push(o);
      //   }
      // });
      // that.GatherDelData.forEach(function (o) {
      //   paraData.push({
      //     name: o.name,
      //     nameZH: o.nameZH,
      //     type: o.type,
      //     unit: o.unit,
      //     rateType: o.rateType,
      //     operateType: "del",
      //   });
      // });
      // if (paraData.length > 0) {
      //   saveGatherList(paraData).then((res) => {
      //     let data = res.result;
      //     that.$message({
      //       message: "点表保存成功！",
      //       type: "success",
      //     });
      //   });
      // }
    },
    deleteCcnInfoById(id) {
      let that = this;
      var para = { id: id };
      deleteCcnInfoById(para)
        .then((res) => {
          let data = res.result;
          that.getCcnInfoList();
          that.$message({
            message: that.$t("tips.deleteSuccess"),
            type: "success",
          });
        })
        .catch((err) => {
          that.$message({
            showClose: true,
            message: err.error.message,
            type: "error",
          });
        });
    },
    deleteGather(id) {
      let that = this;
      var para = { id: id };
      deleteGather(para)
        .then((res) => {
          let data = res.result;
          that.getGatherMainInfoList();
          that.getGatherInfoList();
          that.$message({
            message: that.$t("tips.deleteSuccess"),
            type: "success",
          });
        })
        .catch((err) => {
          that.$message({
            showClose: true,
            message: err.error.message,
            type: "error",
          });
        });
    },
    getCopyCcnGatherList(ccn, version, ccnModel) {
      let that = this;
      that.CCNTable = [];
      that.AllCCNGatherList.forEach(function (obj) {
        if (obj.presetDesc == ccnModel) {
          that.CCNTable.push(obj);
        }
      });
      that.CCNTable.forEach(function (obj) {
        if (that.$refs.CCNTable != undefined) {
          that.$refs.CCNTable.toggleRowSelection(obj, false);
        }
      });
      getCcnGatherList(ccn, version).then((res) => {
        let data = res.result;
        that.CcnGatherData = data;
        if (that.CcnGatherData.ccnGathers.length > 0) {
          that.CCNTable.forEach(function (obj) {
            if (that.$refs.CCNTable != undefined) {
              that.$refs.CCNTable.toggleRowSelection(obj, false);
            }
            that.CcnGatherData.ccnGathers.forEach(function (o) {
              if (obj.id == o.gatherId) {
                obj.address = o.address;
                obj.offset = o.offset;
                obj.scale = o.scale;
                if (
                  obj.address != null &&
                  obj.address != "" &&
                  obj.address != undefined
                )
                  if (that.$refs.CCNTable != undefined) {
                    that.$refs.CCNTable.toggleRowSelection(obj, true);
                  }
              }
            });
          });
        }
        if (that.CcnGatherData.ccnGatherReturns.length > 0) {
          that.CcnGatherData.ccnGatherReturns.forEach(function (o) {
            that.FaultTable.push({
              faultcode: o.returnCode,
              faultcn: o.returnDesc,
              faulttype: o.returnType,
            });
          });
        }
      });
    },
    getCcnGatherList(version) {
      let that = this;
      getCcnGatherList(that.ccnform.ccn, version).then((res) => {
        let data = res.result;
        that.CcnGatherData = data;
        if (that.CcnGatherData.ccnGathers.length > 0) {
          that.CCNTable.forEach(function (obj) {
            if (that.$refs.CCNTable != undefined) {
              that.$refs.CCNTable.toggleRowSelection(obj, false);
            }
            that.CcnGatherData.ccnGathers.forEach(function (o) {
              if (obj.id == o.gatherId) {
                obj.address = o.address;
                obj.offset = o.offset;
                obj.scale = o.scale;
                if (
                  obj.address != null &&
                  obj.address != "" &&
                  obj.address != undefined
                )
                  if (that.$refs.CCNTable != undefined) {
                    that.$refs.CCNTable.toggleRowSelection(obj, true);
                  }
              }
            });
          });
        }
        if (that.CcnGatherData.ccnGatherReturns.length > 0) {
          that.CcnGatherData.ccnGatherReturns.forEach(function (o) {
            that.FaultTable.push({
              faultcode: o.returnCode,
              faultcn: o.returnDesc,
              faulttype: o.returnType,
              expertAdvice: o.expertAdvice,
            });
          });
        }
      });
    },
    cancelQuery() {
      this.searchCcn = "";
      this.searchCcnVersion = "";
      this.getCcnInfoList("search");
    },
    showAdd() {
      let that = this;
      that.ActiveTab = "first";
      that.ccnform.ccn = "";
      that.ccnform.version = "";
      that.ccnform.brand = localStorage.getItem("user_brand")
        ? localStorage.getItem("user_brand")
        : "IR";
      that.ccnform.ccnmodel = "";
      that.upgradeCcnVersion = "";
      that.CCNTableFlag = false;
      that.dialogAddCCN = true;
      that.CCNTable = this.AllCCNGatherList;
      that.CCNTable.forEach(function (obj) {
        obj.address = "";
        if (that.$refs.CCNTable != undefined) {
          that.$refs.CCNTable.toggleRowSelection(obj, false);
        }
      });
      that.ccnform.type = "1";
      that.FaultTable = [];

      that.setHeight();
    },

    cancelGatherQuery() {
      let that = this;
      that.gatherMainSearchform.searchGatherName = "";
      that.gatherMainSearchform.searchCcnModel = "";
      that.gatherMainSearchform.searchRateType = "";
      that.searchGatherMainList();
    },
    showGather() {
      let that = this;
      that.gatherMainSearchform.searchGatherName = "";
      that.gatherMainSearchform.searchCcnModel = "";
      that.gatherMainSearchform.searchRateType = "";
      that.DBGatherMainTable = that.DBMenuTable;
      that.dialogDBMenu = true;
    },
    showCopyCcn(editCcn, editVersion, ccnModel) {
      let that = this;
      that.CCNTableFlag = false;
      that.CCNTable = [];
      that.AllCCNGatherList.forEach(function (obj) {
        if (obj.presetDesc == ccnModel) {
          that.CCNTable.push(obj);
        }
      });
      that.CCNTable.forEach(function (obj) {
        obj.address = "";
      });
      that.dialogAddCCN = true;
      that.ccnform.type = "4";
      that.ccnform.ccn = "";
      that.ccnform.version = "";
      that.ccnform.ccnmodel = "";
      that.FaultTable = [];
      that.getCopyCcnGatherList(editCcn, editVersion, ccnModel);
      that.setHeight();
    },
    showUpgrade(editCcn, editVersion, ccnModel) {
      let that = this;
      that.CCNTableFlag = false;
      that.CCNTable = [];
      that.AllCCNGatherList.forEach(function (obj) {
        if (obj.presetDesc == ccnModel) {
          that.CCNTable.push(obj);
        }
      });
      that.CCNTable.forEach(function (obj) {
        obj.address = "";
      });
      that.dialogAddCCN = true;
      that.ccnform.type = "3";
      that.ccnform.ccn = editCcn;
      that.upgradeCcnVersion = (parseInt(editVersion) + 1)
        .toString()
        .padStart(6, 0);
      that.ccnform.version = "";
      that.ccnform.ccnmodel = ccnModel;
      that.FaultTable = [];
      that.getCcnGatherList(editVersion);
      that.setHeight();
    },
    async showEdit(editCcn, editVersion, ccnmodel, brand) {
      let that = this;
      that.ActiveTab = "first";
      that.upgradeCcnVersion = "";
      that.CCNTableFlag = false;
      that.dialogAddCCN = true;
      that.CCNTable = [];
      that.AllCCNGatherList.forEach(function (obj) {
        if (obj.presetDesc == ccnmodel) {
          that.CCNTable.push(obj);
        }
      });
      that.CCNTable.forEach(function (obj) {
        obj.address = "";
        if (that.$refs.CCNTable != undefined) {
          that.$refs.CCNTable.toggleRowSelection(obj, false);
        }
      });
      that.ccnform.type = "2";
      that.ccnform.ccn = editCcn;
      that.ccnform.version = editVersion;
      that.ccnform.ccnmodel = ccnmodel;
      that.ccnform.brand = brand;
      that.FaultTable = [];
      await that.getCcnGatherList(editVersion);
      that.setHeight();
    },

    showGatherAdd() {
      let that = this;
      that.gatherform.id = "";
      that.gatherform.name = "";
      that.gatherform.nameZH = "";
      that.gatherform.type = "";
      that.gatherform.unit = "";
      that.gatherform.address == "";
      that.gatherform.rate == "";
      that.gatherform.rateType = "";
      that.gatherform.presetDesc = "";
      that.gatherform.offset = "";
      that.gatherform.scale = "";
      that.gatherform.isPreset = "";
      that.addGatherTitle = this.$t("title.AddPointTableData");
      that.dialogAddGather = true;
    },
    showGatherEdit(row) {
      let that = this;
      that.gatherform.id = row.id;
      that.gatherform.name = row.name;
      that.gatherform.nameZH = row.nameZH;
      that.gatherform.type = row.type;
      that.gatherform.unit = row.unit;
      that.gatherform.rate = row.rate == 0 ? "" : row.rate;
      that.gatherform.rateType = row.rateType;
      that.gatherform.presetDesc = row.presetDesc;
      that.gatherform.offset = row.offset;
      that.gatherform.scale = row.scale;
      that.gatherform.isPreset = row.isPreset;
      that.addGatherTitle = this.$t("title.EditPointTableData");
      that.dialogAddGather = true;
    },
    cancelCcnGather() {
      this.FaultTable = [];
      this.dialogAddCCN = false;
    },
    addCcnGather() {
      let that = this;
      var addData = [];
      var faultData = [];
      var saveData = {};
      that.CCNTable.forEach(function (obj) {
        if (
          obj.address != "" &&
          obj.address != null &&
          obj.address != undefined
        ) {
          addData.push({
            GatherId: obj.id,
            Address: obj.address,
            Offset: obj.offset,
            Scale: obj.scale,
            Unit: obj.unit,
          });
        }
      });
      var isPassFault = true;
      that.FaultTable.forEach(function (obj) {
        if (obj.faultcode != "") {
          if (obj.faultcn == "" || obj.faulttype == "") isPassFault = false;
          faultData.push({
            ReturnCode: obj.faultcode,
            ReturnDesc: obj.faultcn,
            ReturnType: obj.faulttype,
            ExpertAdvice: obj.expertAdvice,
          });
        }
      });
      if (!isPassFault) {
        that.$message({
          message: "错误信息添加有误，不能保存",
          type: "warning",
        });
        return;
      }
      if (that.ccnform.ccn.trim() == "") {
        that.$message({
          message: "CCN号不能为空",
          type: "warning",
        });
        return;
      }
      if (that.ccnform.ccnmodel.trim() == "") {
        that.$message({
          message: "控制器型号不能为空",
          type: "warning",
        });
        return;
      }
      if (addData.length == 0) {
        that.$message({
          message: "监控指标为空，不能保存",
          type: "warning",
        });
        return;
      }
      saveData = {
        Ccn: that.ccnform.ccn,
        CcnModel: that.ccnform.ccnmodel,
        BrandCode: that.ccnform.brand,
        CcnType: that.curType,
        Version:
          that.upgradeCcnVersion != ""
            ? that.upgradeCcnVersion
            : that.ccnform.version,
        CcnGathers: addData,
        CcnGatherReturns: faultData,
      };
      if (
        that.ccnform.type == "1" ||
        that.ccnform.type == "3" ||
        that.ccnform.type == "4"
      ) {
        var res = addCcnGather(saveData).then((res) => {
          if (res.result) {
            that.dialogAddCCN = false;
            that.ccnform.ccn = "";
            that.ccnform.version = "";
            that.ccnform.ccnmodel = "";
            if (that.ccnform.type == "1" || that.ccnform.type == "4") {
              that.$message({
                message: that.$t("tips.saveSuccess"),
                type: "success",
              });
            } else {
              that.$message({
                message: that.$t("tips.updateSuccess"),
                type: "success",
              });
            }
            that.ccnform.type = "1";
            that.FaultTable = [];
            that.getGatherInfoList();
            that.getCcnInfoList();
          }
        });
      } else if (that.ccnform.type == "2") {
        editCcnGather(saveData).then((res) => {
          if (res.result) {
            that.dialogAddCCN = false;
            that.ccnform.ccn = "";
            that.ccnform.version = "";
            that.ccnform.ccnmodel = "";
            that.ccnform.type = "1";
            that.$message({
              message: that.$t("tips.updateSuccess"),
              type: "success",
            });
            that.FaultTable = [];
            that.getGatherInfoList();
            that.getCcnInfoList();
          }
        });
      }
    },
    exportCcn(ccn, version) {
      let that = this;
      // var data = {
      //   Ccn: ccn,
      //   Version: version,
      // };
      var headers = [
          { key: "gatherName", title: that.$t("title.monitorIndex") },
          { key: "gatherNameZH", title: that.$t("title.monitorDesc") },
          { key: "dataType", title: that.$t("title.monitorDataType") },
          { key: "unit", title: that.$t("title.monitorUnit") },
          { key: "rateType", title: that.$t("title.monitorType") },
          { key: "address", title: that.$t("title.monitorAddress") },
          { key: "offset", title: that.$t("title.offset") },
          { key: "scale", title: that.$t("title.scale") },
        ];
        var headers2 = [
          { key: "returnCode", title: that.$t("title.errorCode") },
          { key: "returnDesc", title: that.$t("title.errorDescription") },
          { key: "returnType", title: that.$t("title.errorType") },
          { key: "expertAdvice", title: that.$t("title.expertAdvice") },
        ];
  
        var fileName = that.$t("exportContent.点表导出")+" - " + ccn + " - " + version + ".xlsx";
      getCcnExportInfo(ccn, version, that.curType).then((res) => {
        if (res.result) {
          var data = res.result;
          var data_gather = data.ccnGathers;
          var data_return = data.ccnGatherReturns;
          exportExcelCcn(headers, data_gather, headers2, data_return, fileName);
        }
      });
    },
    exportCcnList() {
      let that = this;

      var excelData1 = [
          [
            that.$t('title.brandDisplay'),
            "CCN",
            that.$t('title.ccnVersion'),
            that.$t('title.controllerModel'),
            that.$t("title.monitorIndex"),
            that.$t("title.monitorDesc"),
            that.$t("title.monitorDataType"),
            that.$t("title.monitorUnit"),
            that.$t("title.monitorType"),
            that.$t("title.monitorAddress"),
            that.$t("title.offset"),
            that.$t("title.scale"),
          ],
        ];
  
        var excelData2 = [
          [
          that.$t('title.brandDisplay'),
            "CCN",
            that.$t('title.ccnVersion'),
            that.$t('title.controllerModel'),
            that.$t("title.errorCode"),
            that.$t("title.errorDescription"),
            that.$t("title.errorType"),
            that.$t("title.expertAdvice"),
          ],
        ];
  
        var fileName =
          that.$t("exportContent.点表导出") + " " + that.formatDate(new Date(), "yyyyMMddhhmmss") + ".xlsx";

      var searchCcn = that.searchCcn.trim();
      var searchCcnVersion = that.searchCcnVersion.trim();
      var queryModel = {
        ccn: searchCcn,
        ccnVersion: searchCcnVersion,
        ccnType: that.curType,
      };
      getCcnExportInfoList(queryModel).then((res) => {
        if (res.result) {
          var data = res.result;
          var data_gather = data.ccnGathers;
          var data_return = data.ccnGatherReturns;
          if (data_gather != null && data_gather.length > 0) {
            data_gather.forEach((item) => {
              let rowData = [];
              rowData = [
                item.brandCode,
                item.ccn,
                item.ccnVersion,
                item.ccnModel,
                item.gatherName,
                item.gatherNameZH,
                item.dataType,
                item.unit,
                item.rateType,
                item.address,
                item.offset,
                item.scale,
              ];
              excelData1.push(rowData);
            });
          }

          if (data_return != null && data_return.length > 0) {
            data_return.forEach((item) => {
              let rowData = [];
              rowData = [
                item.brandCode,
                item.ccn,
                item.ccnVersion,
                item.ccnModel,
                item.returnCode,
                item.returnDesc,
                item.returnType,
                item.expertAdvice,
              ];
              excelData2.push(rowData);
            });
          }
          exportExcelCcnList(excelData1, excelData2, fileName);
        }
      });
    },

    exportGatherList() {
      this.loading = true;
      let that = this;
      var exportData = [
        [
          that.$t("title.monitorIndex"),
          that.$t("title.monitorDesc"),
          that.$t("title.monitorDataType"),
          that.$t("title.monitorUnit"),
          that.$t("title.monitorAddress"),
          that.$t("title.monitorType"),
          that.$t('title.controllerModel'),
          that.$t("exportContent.defaultOrNot"),
          that.$t("title.offset"),
          that.$t("title.scale"),
        ],
      ];
      var fileName = that.$t("exportContent.点表总目录导出") + ".xlsx";
      var ccnModel = that.gatherMainSearchform.searchCcnModel;
      var gatherName = that.gatherMainSearchform.searchGatherName;
      var rateType = that.gatherMainSearchform.searchRateType;
      getExportGatherInfos(that.curType, ccnModel, gatherName, rateType).then(
        (res) => {
          if (res.result) {
            var data = res.result;
            //导入数据里有null会导致文件损坏
            const dataSource = data.map((item) => {
              Object.keys(item).forEach((key) => {
                // 后端传null node写入会有问题
                if (item[key] === null) {
                  item[key] = "";
                }

                if (Array.isArray(item[key])) {
                  item[key] = item[key].join(",");
                }
              });
              return item;
            });
            dataSource.forEach((item) => {
              let rowData = [];
              rowData = [
                item.name,
                item.nameZH,
                item.type,
                item.unit,
                item.rate,
                item.rateType,
                item.presetDesc,
                item.isPreset,
                item.offset,
                item.scale,
              ];
              exportData.push(rowData);
            });
            exportExcelNew(exportData, fileName);
            this.loading = false;
          }
        }
      );
    },
    openNotice() {
      this.$notify({
        title: "警告",
        message: "这是一条警告的提示消息",
        type: "warning",
      });
    },
    togleCollapse() {
      this.isCollapse = !this.isCollapse;
    },

    handleAccredit(index, row) {
      //console.log(index, row);
    },
    handleDelete(index, row) {
      //console.log(index, row);
    },
    onSubmit() {},
    handleClick() {},
    handleCurrentChange() {},

    // 增加行  错误信息
    addFaulRow() {
      var list = {
        faultrowNum: this.faultrowNum,
        faultcode: "",
        faultcn: "",
        faulttype: "",
      };
      //this.FaultTable.unshift(list);
      this.FaultTable.push(list);
      this.faultrowNum += 1;
    },
    // 删除选中行 错误信息
    delFaultRow(index, row) {
      this.FaultTable.splice(index, 1);
    },

    // 增加行  CCN总表
    addDBRow() {
      var list = {
        DBrowNum: this.DBrowNum,
        faultcode: "",
        faultcn: "",
        faulttype: "",
      };
      this.DBMenuTable.unshift(list);
      this.DBrowNum += 1;
    },
    // 删除选中行 CCN总表
    delDBRow(index, row) {
      this.DBMenuTable.splice(index, 1);
      this.GatherDelData.push(row);
    },
    //创建ccn时，选择点表目录
    handleSelectionChange(val) {
      this.multipleSelection = val;
    },

    CCNbtn(row, col, event) {
      //选择点表， 点击行进行勾选
      if (row.address != "" && row.address != null && row.address != undefined)
        this.$refs.CCNTable.toggleRowSelection(row, true);
      else {
        this.CCNTableFlag = !this.CCNTableFlag;
        this.$refs.CCNTable.toggleRowSelection(row, this.CCNTableFlag);
      }
    },
    showImportDialog(visible) {
      this.dialogImportClient = visible;
      // this.form.datalist = [];
      if (this.$refs.importRef.$refs.airFormImport != undefined) {
        this.$refs.importRef.$refs.airFormImport.resetFields();
      }
    },
    showImportExpertAdviceDialog(visible) {
      this.dialogImportExpertAdviceClient = visible;
      // this.form.datalist = [];
      if (this.$refs.importExpertAdviceRef.$refs.airFormImport != undefined) {
        this.$refs.importExpertAdviceRef.$refs.airFormImport.resetFields();
      }
    },
    uploadFile() {
        let that = this;
        var datalist = that.form.datalist;
        var dbData = [];
        var errInfoData = [];
        var msgArr = [];
        datalist.forEach((e, i) => {
          var propertys = Object.keys(e);
  
          var index = 2;
          if (that.activeLang == 'en') {
            if (e.sheetName == "Ccn") {
              e.data.map((v) => {
                let obj = {};
                obj.Ccn = v["CCN"];
                obj.CcnVersion = v["CCN Version"];
                obj.CcnModel = v["Controller Model"];
                obj.GatherName = v["Monitor Index"];
                obj.GatherNameZH = v["Index Description"];
                obj.DataType = v["Data Type"];
                obj.Unit = v["Unit"];
                obj.RateType = v["Return Type"];
                obj.Address = v["Address"];
                obj.BrandCode = v["Brand"];
  
                if (obj.Ccn == undefined || obj.Ccn == "") {
                  msgArr.push(
                    that.$t("importError.exceptionSheet") +
                      e.sheetName +
                      that.$t("importError.数据第") +
                      index +
                      that.$t("importError.行异常:")+
                      that.$t("importError.ccnIsEmpty")
                  );
                }
                if (obj.GatherName == undefined || obj.GatherName == "") {
                  msgArr.push(
                    that.$t("importError.exceptionSheet") +
                      e.sheetName +
                      that.$t("importError.数据第") +
                      index +
                      that.$t("importError.行异常:")+
                      that.$t("importError.monitorIndexIsEmpty")
                  );
                }
                if (that.find(dbData, obj) > -1) {
                  msgArr.push(
                    that.$t("importError.exceptionLine") +
                      index +
                      that.$t("importError.行异常:")+
                      that.$t("importError.theSameCcnAlreadyExists") +
                      obj.Ccn
                  );
                } else {
                  dbData.push(obj);
                }
                index++;
              });
            } else if (e.sheetName == "Error Message") {
              e.data.map((v) => {
                let obj = {};
                obj.Ccn = v["CCN"];
                obj.CcnVersion = v["CCN Version"];
                obj.CcnModel = v["Controller Model"];
                obj.ReturnCode = v["Error Code"];
                obj.ReturnDesc = v["Error Description"];
                obj.ReturnType = v["Error Type"];
                obj.ExpertAdvice = v["Expert Advice"];
                obj.BrandCode = v["Brand"];
  
                if (obj.Ccn == undefined || obj.Ccn == "") {
                  msgArr.push(
                    that.$t("importError.exceptionSheet") +
                      e.sheetName +
                      that.$t("importError.数据第") +
                      index +
                      that.$t("importError.行异常:")+
                      that.$t("importError.ccnIsEmpty")
                  );
                }
  
                if (obj.ReturnCode == undefined || obj.ReturnCode == "") {
                  msgArr.push(
                    that.$t("importError.exceptionSheet") +
                      e.sheetName +
                      that.$t("importError.数据第") +
                      index +
                      that.$t("importError.行异常:")+
                      that.$t("importError.errorCodeIsEmpty")
                  );
                }
                if (obj.ReturnDesc == undefined || obj.ReturnDesc == "") {
                  msgArr.push(
                    that.$t("importError.exceptionSheet") +
                      e.sheetName +
                      that.$t("importError.数据第") +
                      index +
                      that.$t("importError.行异常:")+
                      that.$t("importError.errorDescriptionIsEmpty")
                  );
                }
                if (obj.ReturnType == undefined || obj.ReturnType == "") {
                  msgArr.push(
                    that.$t("importError.exceptionSheet") +
                      e.sheetName +
                      that.$t("importError.数据第") +
                      index +
                      that.$t("importError.行异常:")+
                      that.$t("importError.errorTypeIsEmpty")
                  );
                }
                errInfoData.push(obj);
                index++;
              });
            } else {
              msgArr.push(that.$t("importError.readFailCcn"));
            }
          } else {
            if (e.sheetName == "点表") {
            e.data.map((v) => {
              let obj = {};
              obj.Ccn = v["CCN"];
              obj.CcnVersion = v["CCN版本号"];
              obj.CcnModel = v["控制器型号"];
              obj.GatherName = v["监控指标"];
              obj.GatherNameZH = v["指标描述"];
              obj.DataType = v["类型"];
              obj.Unit = v["单位"];
              obj.RateType = v["回传类型"];
              obj.Address = v["地址值"];
              obj.BrandCode = v["品牌"];
  
              if (obj.Ccn == undefined || obj.Ccn == "") {
                msgArr.push(
                  "Excel表格读取" +
                    e.sheetName +
                    "数据第" +
                    index +
                    "行异常，Ccn号为空"
                );
              }
              if (obj.GatherName == undefined || obj.GatherName == "") {
                msgArr.push(
                  "Excel表格读取" +
                    e.sheetName +
                    "数据第" +
                    index +
                    "行异常，监控指标为空"
                );
              }
              if (that.find(dbData, obj) > -1) {
                msgArr.push(
                  that.$t("importError.exceptionLine") +
                    index +
                    that.$t("importError.行异常:")+
                    that.$t("importError.theSameCcnAlreadyExists") +
                    obj.Ccn
                );
              } else {
                dbData.push(obj);
              }
              index++;
            });
          } else if (e.sheetName == "错误信息") {
            e.data.map((v) => {
              let obj = {};
              obj.Ccn = v["CCN"];
              obj.CcnVersion = v["CCN版本号"];
              obj.CcnModel = v["控制器型号"];
              obj.ReturnCode = v["故障代码"];
              obj.ReturnDesc = v["故障描述"];
              obj.ReturnType = v["故障类型"];
              obj.ExpertAdvice = v["专家建议"];
              obj.BrandCode = v["品牌"];
  
              if (obj.Ccn == undefined || obj.Ccn == "") {
                msgArr.push(
                  "Excel表格读取" +
                    e.sheetName +
                    "数据第" +
                    index +
                    "行异常，Ccn号为空"
                );
              }
  
              if (obj.ReturnCode == undefined || obj.ReturnCode == "") {
                msgArr.push(
                  "Excel表格读取" +
                    e.sheetName +
                    "数据第" +
                    index +
                    "行异常，故障代码为空"
                );
              }
              if (obj.ReturnDesc == undefined || obj.ReturnDesc == "") {
                msgArr.push(
                  "Excel表格读取" +
                    e.sheetName +
                    "数据第" +
                    index +
                    "行异常，故障描述为空"
                );
              }
              if (obj.ReturnType == undefined || obj.ReturnType == "") {
                msgArr.push(
                  "Excel表格读取" +
                    e.sheetName +
                    "数据第" +
                    index +
                    "行异常，故障类型为空"
                );
              }
              errInfoData.push(obj);
              index++;
            });
          } else {
            msgArr.push("Excel表格读取失败，未找到“点表”和“错误信息”的Sheet");
          }
          }
          
        });
        if (msgArr.length > 0) {
          that.$message({
            showClose: true,
            dangerouslyUseHTMLString: true,
            message: msgArr.join("<br/>"),
            type: "error",
          });
          return false;
        }
        var postData = {
          CcnType: that.curType,
          CcnGatherFulls: dbData,
          CcnGatherReturnFulls: errInfoData,
        };
        importCcnInfosPac(postData)
          .then((res) => {
            that.dialogImportClient = false;
            that.$message({
              showClose: true,
              message: that.$t("tips.importSuccess"),
              type: "success",
            });
            that.getGatherInfoList();
            that.getCcnInfoList();
          })
          .catch((err) => {
            that.$message({
              showClose: true,
              message: err.error.message,
              type: "error",
            });
          });
      },
    find(array, model) {
      let arrayStr = JSON.stringify(array);
      let modelStr = JSON.stringify(model);
      let index = arrayStr.indexOf(modelStr);
      return index; // -1 说明array中不存在id为str的对象
    },
    uploadExpertAdvice() {
        let that = this;
        var datalist = that.form.datalist;
        var errInfoData = [];
        var msgArr = [];
        datalist.forEach((e, i) => {
          var propertys = Object.keys(e);
          var index = 2;
          if (that.activeLang == 'en') {
            if (e.sheetName == "Expert Advice" || e.sheetName == "Sheet1") {
            e.data.map((v) => {
              let obj = {};
              obj.Ccn = v["CCN"];
              obj.CcnVersion = v["CCN Version"];
              obj.CcnModel = v["Controller Model"];
              obj.ReturnCode = v["Error Code"];
              obj.ReturnDesc = v["Error Description"];
              obj.ReturnType = v["Error Type"];
              obj.BrandCode = v["Brand"];
              obj.ExpertAdvice = v["Expert Advice"];
  
              if (obj.Ccn == undefined || obj.Ccn == "") {
                msgArr.push(
                  that.$t("importError.exceptionSheet") +
                      e.sheetName +
                      that.$t("importError.数据第") +
                      index +
                      that.$t("importError.行异常:")+
                      that.$t("importError.ccnIsEmpty")
                );
              }
  
              if (obj.ReturnCode == undefined || obj.ReturnCode == "") {
                msgArr.push(
                  that.$t("importError.exceptionSheet") +
                      e.sheetName +
                      that.$t("importError.数据第") +
                      index +
                      that.$t("importError.行异常:")+
                      that.$t("importError.errorCodeIsEmpty")
                );
              }
              if (obj.ReturnDesc == undefined || obj.ReturnDesc == "") {
                msgArr.push(
                  that.$t("importError.exceptionSheet") +
                      e.sheetName +
                      that.$t("importError.数据第") +
                      index +
                      that.$t("importError.行异常:")+
                      that.$t("importError.errorDescriptionIsEmpty")
                );
              }
              if (obj.ReturnType == undefined || obj.ReturnType == "") {
                msgArr.push(
                  that.$t("importError.exceptionSheet") +
                      e.sheetName +
                      that.$t("importError.数据第") +
                      index +
                      that.$t("importError.行异常:")+
                      that.$t("importError.errorTypeIsEmpty")
                );
              }
              if (obj.ExpertAdvice == undefined || obj.ExpertAdvice == "") {
                msgArr.push(
                  that.$t("importError.exceptionSheet") +
                      e.sheetName +
                      that.$t("importError.数据第") +
                      index +
                      that.$t("importError.行异常:")+
                      that.$t("importError.expertAdviceIsEmpty")
                );
              }
              errInfoData.push(obj);
              index++;
            });
          } else {
            msgArr.push(that.$t("importError.readFailExpertAdvice"));
          }
          } else {
            if (e.sheetName == "专家建议" || e.sheetName == "Sheet1") {
            e.data.map((v) => {
              let obj = {};
              obj.Ccn = v["CCN"];
              obj.CcnVersion = v["CCN版本号"];
              obj.CcnModel = v["控制器型号"];
              obj.ReturnCode = v["故障代码"];
              obj.ReturnDesc = v["故障描述"];
              obj.ReturnType = v["故障类型"];
              obj.BrandCode = v["品牌"];
              obj.ExpertAdvice = v["专家建议"];
  
              if (obj.Ccn == undefined || obj.Ccn == "") {
                msgArr.push(
                  "Excel表格读取" +
                    e.sheetName +
                    "数据第" +
                    index +
                    "行异常，Ccn号为空"
                );
              }
  
              if (obj.ReturnCode == undefined || obj.ReturnCode == "") {
                msgArr.push(
                  "Excel表格读取" +
                    e.sheetName +
                    "数据第" +
                    index +
                    "行异常，故障代码为空"
                );
              }
              if (obj.ReturnDesc == undefined || obj.ReturnDesc == "") {
                msgArr.push(
                  "Excel表格读取" +
                    e.sheetName +
                    "数据第" +
                    index +
                    "行异常，故障描述为空"
                );
              }
              if (obj.ReturnType == undefined || obj.ReturnType == "") {
                msgArr.push(
                  "Excel表格读取" +
                    e.sheetName +
                    "数据第" +
                    index +
                    "行异常，故障类型为空"
                );
              }
              if (obj.ExpertAdvice == undefined || obj.ExpertAdvice == "") {
                msgArr.push(
                  "Excel表格读取" +
                    e.sheetName +
                    "数据第" +
                    index +
                    "行异常，专家建议为空"
                );
              }
              errInfoData.push(obj);
              index++;
            });
          } else {
            msgArr.push("Excel表格读取失败，未找到“专家建议”的Sheet");
          }
          }
          
        });
        if (msgArr.length > 0) {
          that.$message({
            showClose: true,
            dangerouslyUseHTMLString: true,
            message: msgArr.join("<br/>"),
            type: "error",
          });
          return false;
        }
        // var postData = {
        //   data: errInfoData,
        // };
        importExpertAdvices(errInfoData)
          .then((res) => {
            that.dialogImportExpertAdviceClient = false;
            that.dialogAddCCN = false;
            that.$message({
              showClose: true,
              message: that.$t("tips.importSuccess"),
              type: "success",
            });
            that.getCcnGatherList(that.ccnform.version);
          })
          .catch((err) => {
            that.$message({
              showClose: true,
              message: err.error.message,
              type: "error",
            });
          });
    },
    formatDate(date, fmt) {
      var that = this;
      if (/(y+)/.test(fmt)) {
        fmt = fmt.replace(
          RegExp.$1,
          (date.getFullYear() + "").substr(4 - RegExp.$1.length)
        );
      }
      let o = {
        "M+": date.getMonth() + 1,
        "d+": date.getDate(),
        "h+": date.getHours(),
        "m+": date.getMinutes(),
        "s+": date.getSeconds(),
      };
      for (let k in o) {
        if (new RegExp(`(${k})`).test(fmt)) {
          let str = o[k] + "";
          fmt = fmt.replace(
            RegExp.$1,
            RegExp.$1.length === 1 ? str : that.padLeftZero(str)
          );
        }
      }
      return fmt;
    },

    padLeftZero(str) {
      return ("00" + str).substr(str.length);
    },

    openWarningInfoDialog(row) {
      debugger;
      var d = row;
      d.expertAdviceList = [];
      if (
        d.expertAdvice != "" &&
        d.expertAdvice != null &&
        d.expertAdvice != undefined
      ) {
        var arr = d.expertAdvice.split("|");
        arr.forEach(function (o) {
          var arr2 = o.split(":");
          if (arr2.length == 2) {
            d.expertAdviceList.push({
              reason: arr2[0],
              solution: arr2[1],
            });
          } else if (arr2.length == 1) {
            d.expertAdviceList.push({
              reason: "",
              solution: arr2[0],
            });
          }
        });
      }
      this.TripInfo = d;
      this.dialogWarningInfo = true;
    },

    doClose() {
      this.dialogWarningInfo = false;
    },
    jumpGatherUnit() {
      this.$router.push({
        name: "/ccn/gatherUnit",
      });
    },
  },
};
</script>
 
